import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'
import { ElMessage } from 'element-plus'
import { getCurrentTenantPublicInfo } from '@/api/tenantPublicInfo'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    redirect: '/data-board/base-data',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'data-board/base-data',
        name: 'DataBoardBaseData',
        component: () => import('@/views/dataBoard/BaseDataView.vue'),
        meta: {
          title: '基础数据',
          permission: 'BASE_DATA_BOARD'
        }
      },
      {
        path: 'data-board/deep-data/overview',
        name: 'DeepDataOverview',
        component: () => import('@/views/dataBoard/DeepDataOverview.vue'),
        meta: {
          title: '深度数据总览',
          permission: 'DEEP_ANALYSIS_BOARD'
        }
      },
      {
        path: 'data-board/deep-data/progress-curve',
        name: 'ProgressCurve',
        component: () => import('@/views/dataBoard/ProgressCurveView.vue'),
        meta: {
          title: '进步曲线',
          permission: 'DEEP_ANALYSIS_BOARD'
        }
      },
      {
        path: 'data-board/student-archive',
        name: 'StudentArchive',
        component: () => import('@/views/dataBoard/StudentArchiveView.vue'),
        meta: {
          title: '学生档案',
          permission: 'USER_STUDENT_VIEW'
        }
      },
      {
        path: 'data-board/student-archive/detail',
        name: 'StudentArchiveDetail',
        component: () => import('@/views/dataBoard/StudentArchiveDetail.vue'),
        meta: {
          title: '学生档案详情',
          permission: 'USER_STUDENT_VIEW'
        }
      },

      {
        path: 'detection/resume-detection',
        name: 'DetectionResumeDetection',
        component: () => import('@/views/detection/ResumeDetectionView.vue'),
        meta: {
          title: '简历检测',
          permission: 'COLLEGE_STUDENT_ATS_HISTORY'
        }
      },
      {
        path: 'detection/interview-analysis',
        name: 'DetectionInterviewAnalysis',
        component: () => import('@/views/detection/InterviewAnalysisView.vue'),
        meta: {
          title: '面试解析',
          permission: 'COLLEGE_STUDENT_ATS_HISTORY'
        }
      },
      {
        path: 'detection/mock-interview',
        name: 'DetectionMockInterview',
        component: () => import('@/views/detection/MockInterviewView.vue'),
        meta: {
          title: '模拟面试',
          permission: 'COLLEGE_STUDENT_ATS_HISTORY'
        }
      },
      {
        path: 'detection/stress-interview',
        name: 'DetectionStressInterview',
        component: () => import('@/views/detection/StressInterviewView.vue'),
        meta: {
          title: '压力面试',
          permission: 'COLLEGE_STUDENT_ATS_HISTORY'
        }
      },
      {
        path: 'detection/job-resume-match',
        name: 'DetectionJobResumeMatch',
        component: () => import('@/views/detection/JobResumeMatchView.vue'),
        meta: {
          title: '简岗匹配',
          permission: 'COLLEGE_STUDENT_ATS_HISTORY'
        }
      },
      {
        path: 'detection/career-test',
        name: 'DetectionCareerTest',
        component: () => import('@/views/detection/CareerTestRecordView.vue'),
        meta: {
          title: '职业测试',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'detection/student-tips-record',
        name: 'DetectionStudentTipsRecord',
        component: () => import('@/views/detection/StudentTipsRecordView.vue'),
        meta: {
          title: '收藏收录',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/manage',
        name: 'ProductManage',
        component: () => import('@/views/product/ProductManageView.vue'),
        meta: {
          title: '检测产品',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/type',
        name: 'ProductType',
        component: () => import('@/views/product/ProductTypeView.vue'),
        meta: {
          title: '类型管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/loss-job-feedback',
        name: 'LossJobFeedback',
        component: () => import('@/views/product/LossJobFeedbackView.vue'),
        meta: {
          title: '缺失岗位反馈',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/interview-analysis-quota',
        name: 'InterviewAnalysisQuota',
        component: () => import('@/views/product/InterviewAnalysisQuotaView.vue'),
        meta: {
          title: '面试解析配额管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/mock-interview-quota',
        name: 'MockInterviewQuota',
        component: () => import('@/views/product/MockInterviewQuotaView.vue'),
        meta: {
          title: '模拟面试配额管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'product/stress-interview-quota',
        name: 'StressInterviewQuota',
        component: () => import('@/views/product/StressInterviewQuotaView.vue'),
        meta: {
          title: '压力面试配额管理',
          permission: 'ADMIN_ALL'
        }
      },

      {
        path: 'user/mini-app',
        name: 'MiniAppUser',
        component: () => import('@/views/user/MiniAppUserView.vue'),
        meta: {
          title: '小程序用户',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/tenant',
        name: 'TenantManage',
        component: () => import('@/views/user/TenantManageView.vue'),
        meta: {
          title: '租户管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/ehr-user',
        name: 'EhrUser',
        component: () => import('@/views/user/EhrUserView.vue'),
        meta: {
          title: '系统用户',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/auth-code',
        name: 'AuthCode',
        component: () => import('@/views/user/AuthCodeView.vue'),
        meta: {
          title: '授权码管理',
          permission: 'AUTH_CODE_VIEW'
        }
      },
      {
        path: 'user/interview-analysis',
        name: 'InterviewAnalysis',
        component: () => import('@/views/product/InterviewAnalysisView.vue'),
        meta: {
          title: '面试解析管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/interview-analysis-student',
        name: 'InterviewAnalysisStudent',
        component: () => import('@/views/product/InterviewAnalysisStudentView.vue'),
        meta: {
          title: '面试解析白名单',
          permission: 'USER_STUDENT_VIEW'
        }
      },
      {
        path: 'user/mock-interview',
        name: 'MockInterview',
        component: () => import('@/views/product/MockInterviewView.vue'),
        meta: {
          title: '模拟面试管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/mock-interview-student',
        name: 'MockInterviewStudent',
        component: () => import('@/views/product/MockInterviewStudentView.vue'),
        meta: {
          title: '模拟面试白名单',
          permission: 'USER_STUDENT_VIEW'
        }
      },
      {
        path: 'user/stress-interview',
        name: 'StressInterview',
        component: () => import('@/views/product/StressInterviewView.vue'),
        meta: {
          title: '压力面试管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/stress-interview-student',
        name: 'StressInterviewStudent',
        component: () => import('@/views/product/StressInterviewStudentView.vue'),
        meta: {
          title: '压力面试白名单',
          permission: 'USER_STUDENT_VIEW'
        }
      },
      {
        path: 'user/student',
        name: 'StudentUser',
        component: () => import('@/views/user/StudentUserView.vue'),
        meta: {
          title: '学生用户管理',
          permission: 'USER_STUDENT_VIEW'
        }
      },
      {
        path: 'user/tenant-public-info',
        name: 'TenantPublicInfo',
        component: () => import('@/views/user/TenantPublicInfoView.vue'),
        meta: {
          title: '租户公共信息',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'user/operate-log',
        name: 'OperateLog',
        component: () => import('@/views/user/OperateLogView.vue'),
        meta: {
          title: '操作日志',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'permission/role',
        name: 'RoleManage',
        component: () => import('@/views/permission/RoleManageView.vue'),
        meta: {
          title: '角色管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'permission/permission',
        name: 'PermissionManage',
        component: () => import('@/views/permission/PermissionManageView.vue'),
        meta: {
          title: '权限点管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'permission/role-permission',
        name: 'RolePermission',
        component: () => import('@/views/permission/RolePermissionView.vue'),
        meta: {
          title: '角色权限管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'permission/user-role',
        name: 'UserRole',
        component: () => import('@/views/permission/UserRoleView.vue'),
        meta: {
          title: '用户角色管理',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'ai-teaching/profile-modeling',
        name: 'ProfileModeling',
        component: () => import('@/views/aiTeaching/ProfileModelingView.vue'),
        meta: {
          title: '个人画像建模',
          permission: 'ADMIN_ALL'
        }
      },
      {
        path: 'ai-teaching/ai-plan',
        name: 'AiPlan',
        component: () => import('@/views/aiTeaching/AiPlanView.vue'),
        meta: {
          title: 'AI教案',
          permission: 'AI_TEACH_PLAN'
        }
      },
      {
        path: 'ai-teaching/generate-plan',
        name: 'GeneratePlan',
        component: () => import('@/views/aiTeaching/GeneratePlanView.vue'),
        meta: {
          title: '生成教案',
          permission: 'AI_TEACH_PLAN'
        }
      },
      {
        path: 'ai-teaching/plan-detail/:planId',
        name: 'PlanDetail',
        component: () => import('@/views/aiTeaching/PlanDetailView.vue'),
        meta: {
          title: '教案详情',
          permission: 'AI_TEACH_PLAN'
        }
      },
      {
        path: 'system/black-api',
        name: 'BlackApi',
        component: () => import('@/views/system/BlackApiView.vue'),
        meta: {
          title: '黑接口',
          permission: 'ADMIN_ALL'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const token = store.state.user.token

  // 如果访问登录页
  if (to.path === '/login') {
    if (token) {
      // 已登录，跳转到首页
      next('/')
    } else {
      next()
    }
    return
  }

  // 如果需要认证
  if (to.meta.requiresAuth !== false) {
    if (!token) {
      // 未登录，跳转到登录页
      ElMessage.warning('请先登录')
      next('/login')
      return
    }

    // 如果还没有获取权限信息，先获取
    if (!store.state.user.permissions || store.state.user.permissions.length === 0) {
      try {
        await store.dispatch('user/getPermission')
      } catch (error) {
        console.error('获取权限失败:', error)
        ElMessage.error('获取权限信息失败，请重新登录')
        await store.dispatch('user/logout')
        next('/login')
        return
      }
    }

    // 检查页面权限
    if (to.meta.permission) {
      const hasPermission = store.getters['user/hasPermission'](to.meta.permission)
      if (!hasPermission) {
        ElMessage.error('您没有访问该页面的权限')
        next('/dashboard')
        return
      }
    }
  }

  next()
})

export default router










